// 发 Key 时给对方的接法：各个 AI 工具怎么接一个带 Authorization 请求头的远程 MCP（Streamable HTTP）。
// 2026-10 查过各家文档：Claude Code、Cursor、Codex、VS Code、Gemini CLI、Kimi CLI、Qwen Code、Cherry Studio 都能带请求头；
// Claude 桌面版的配置文件不能直接写远程地址，要经 mcp-remote 转一下；ChatGPT、claude.ai 网页版的连接器只认 OAuth，暂时接不了。

export interface ConnectGuide {
  id: string
  name: string
  how: string
  snippet: string
}

export function connectGuides(url: string, key: string): ConnectGuide[] {
  const json = (v: unknown) => JSON.stringify(v, null, 2)
  return [
    {
      id: 'claude-code',
      name: 'Claude Code',
      how: '在终端里运行这一行（--scope user 表示所有项目都能用）。之后在 Claude Code 里输入 /mcp 能看到 lingzhi。',
      snippet: `claude mcp add --transport http lingzhi ${url} --scope user --header "Authorization: Bearer ${key}"`,
    },
    {
      id: 'cursor',
      name: 'Cursor',
      how: '加到 ~/.cursor/mcp.json（没有就新建；已有 mcpServers 的话只加 lingzhi 这一项）。',
      snippet: json({ mcpServers: { lingzhi: { url, headers: { Authorization: `Bearer ${key}` } } } }),
    },
    {
      id: 'codex',
      name: 'Codex',
      how: '加到 ~/.codex/config.toml，再在终端里设好环境变量 LINGZHI_KEY（比如写进 ~/.zshrc）。',
      snippet: `[mcp_servers.lingzhi]\nurl = "${url}"\nbearer_token_env_var = "LINGZHI_KEY"\n\n# ~/.zshrc 里：\nexport LINGZHI_KEY="${key}"`,
    },
    {
      id: 'vscode',
      name: 'VS Code',
      how: '加到项目里的 .vscode/mcp.json（或者用户设置里的 MCP 配置），给 Copilot 的 Agent 模式用。',
      snippet: json({ servers: { lingzhi: { type: 'http', url, headers: { Authorization: `Bearer ${key}` } } } }),
    },
    {
      id: 'claude-desktop',
      name: 'Claude 桌面版',
      how: '设置 → 开发者 → 编辑配置（claude_desktop_config.json），加上这一项，重启 Claude。要先装好 Node.js。',
      snippet: json({ mcpServers: { lingzhi: { command: 'npx', args: ['-y', 'mcp-remote', url, '--header', 'Authorization:${LINGZHI_AUTH}', '--transport', 'http-only'], env: { LINGZHI_AUTH: `Bearer ${key}` } } } }),
    },
    {
      id: 'other',
      name: '其他',
      how: 'Gemini CLI、Kimi CLI、Qwen Code、Cherry Studio 这些：传输方式选 Streamable HTTP（有的叫 http / httpUrl / streamableHttp），地址和请求头照下面填。',
      snippet: `地址：${url}\n请求头：Authorization: Bearer ${key}\n\n# Gemini CLI（Qwen Code、Kimi CLI 把 gemini 换成 qwen、kimi）\ngemini mcp add --transport http lingzhi ${url} --header "Authorization: Bearer ${key}"\n\n# Cherry Studio（设置 → MCP 服务器 → 从 JSON 导入）\n${json({ mcpServers: { lingzhi: { type: 'streamableHttp', url, headers: { Authorization: `Bearer ${key}` } } } })}`,
    },
  ]
}
